module.exports = __webpack_public_path__ + "img/filters-ductwork-cleaned-02-med.9e0aa1a8.jpg";